import React, { Fragment, useEffect, useState } from 'react';
import { NextPage } from 'next';
import { useQuery } from '@apollo/client';

import Layout from '../../components/Layout';
import { HelpDeskHeader, HelpDeskHome } from '../../components/HelpDesk';

import { withApollo } from '../../graphQL/withApollo';
import listQuestions from '../../graphQL/queries/listQuestions';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { helpPageEvents } from '@/utils/dataLayer/helpPage';

const HelpDesk: NextPage = ({ title }: any) => {
  const [categories, setCategories] = useState<HelpDeskCategory[]>([]);

  const { data, loading } = useQuery(listQuestions);

  useEffect(() => {
    if (data && data.listQuestions && !loading) {
      setCategories(
        [...data.listQuestions].sort((categoryA: HelpDeskCategory, categoryB: HelpDeskCategory) =>
          categoryA.order > categoryB.order ? 1 : -1
        )
      );
    }
  }, [data]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    trackEvent({
      eventParams: {
        ...helpPageEvents.home,
      },
    });
  }, []);

  return (
    <Layout title={title}>
      <Fragment>
        <HelpDeskHeader />
        {!loading && <HelpDeskHome categories={categories} />}
      </Fragment>
    </Layout>
  );
};

HelpDesk.getInitialProps = async () => ({
  title: 'Centro de ayuda',
});

export default withApollo(HelpDesk, {
  graphqlGateway: process.env.graphqlGateway,
});
